import { render, staticRenderFns } from "./WomenBenefit.vue?vue&type=template&id=6fe2a1a1"
import script from "./WomenBenefit.vue?vue&type=script&lang=js"
export * from "./WomenBenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports